import { FC, SVGProps } from 'react'

const TrashIcon: FC<SVGProps<SVGSVGElement>> = svgProps => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...svgProps}
  >
    <path
      d="M5.64444 2.10728V2.71469H2.60741C2.27195 2.71469 2 2.98664 2 3.3221V3.9295C2 4.26496 2.27195 4.53691 2.60741 4.53691H13.5407C13.8762 4.53691 14.1481 4.26496 14.1481 3.9295V3.3221C14.1481 2.98664 13.8762 2.71469 13.5407 2.71469H10.5037V2.10728C10.5037 1.77182 10.2318 1.49988 9.89629 1.49988H6.25185C5.91639 1.49988 5.64444 1.77182 5.64444 2.10728Z"
      fill="currentColor"
    />
    <path
      d="M3.16797 5.75159H12.9798L12.4074 13.4788C12.3369 14.4303 11.5444 15.1664 10.5902 15.1664H5.55759C4.60343 15.1664 3.81084 14.4303 3.74035 13.4788L3.16797 5.75159Z"
      fill="currentColor"
    />
  </svg>
)

export default TrashIcon
